var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light-mode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.474,
    height: 23.474,
    viewBox: "0 0 23.474 23.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48271",
    "data-name": "Path 48271",
    d: "M14.869,9A5.869,5.869,0,1,1,9,14.869,5.875,5.875,0,0,1,14.869,9Zm0,9.781a3.912,3.912,0,1,0-3.912-3.912A3.917,3.917,0,0,0,14.869,18.781Z",
    transform: "translate(-3.131 -3.131)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48272",
    "data-name": "Path 48272",
    d: "M17.478,3.912a.978.978,0,0,1-.978-.978V.978a.978.978,0,1,1,1.956,0V2.934A.978.978,0,0,1,17.478,3.912Z",
    transform: "translate(-5.741 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48273",
    "data-name": "Path 48273",
    d: "M17.478,33.912a.978.978,0,0,1-.978-.978V30.978a.978.978,0,0,1,1.956,0v1.956A.978.978,0,0,1,17.478,33.912Z",
    transform: "translate(-5.741 -10.438)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48274",
    "data-name": "Path 48274",
    d: "M7.2,8.175a.975.975,0,0,1-.692-.286L5.116,6.5A.978.978,0,0,1,6.5,5.116L7.889,6.505A.978.978,0,0,1,7.2,8.175Z",
    transform: "translate(-1.681 -1.681)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48275",
    "data-name": "Path 48275",
    d: "M28.407,29.385a.975.975,0,0,1-.692-.286L26.326,27.71a.978.978,0,0,1,1.383-1.383L29.1,27.715a.978.978,0,0,1-.692,1.67Z",
    transform: "translate(-9.06 -9.06)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48276",
    "data-name": "Path 48276",
    d: "M2.934,18.456H.978a.978.978,0,1,1,0-1.956H2.934a.978.978,0,1,1,0,1.956Z",
    transform: "translate(0 -5.741)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48277",
    "data-name": "Path 48277",
    d: "M32.934,18.456H30.978a.978.978,0,1,1,0-1.956h1.956a.978.978,0,1,1,0,1.956Z",
    transform: "translate(-10.438 -5.741)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48278",
    "data-name": "Path 48278",
    d: "M5.808,29.385a.978.978,0,0,1-.692-1.67l1.389-1.389A.978.978,0,0,1,7.889,27.71L6.5,29.1A.975.975,0,0,1,5.808,29.385Z",
    transform: "translate(-1.681 -9.06)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48279",
    "data-name": "Path 48279",
    d: "M27.018,8.175a.978.978,0,0,1-.692-1.67l1.389-1.389A.978.978,0,0,1,29.1,6.5L27.71,7.889A.975.975,0,0,1,27.018,8.175Z",
    transform: "translate(-9.06 -1.681)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light-mode.d7c2228757539471eaa96baaa7f2582a.svg";
export { ForwardRef as ReactComponent };